<script setup>
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import TableFiles from "@/Components/TableFiles.vue";

const props = defineProps({
    origin_type: String,
    files: Array,
    columnas: Array,
    object_target: {
        type: Array,
        default: () => []
    },
    files_date_diff_days: {
        type: Number,
        default: 15
    },
    message: String,
    canView: {
        type: Boolean,
        default: true
    },
    canDownload: {
        type: Boolean,
        default: true
    },
    canEdit: {
        type: Boolean,
        default: true
    },
});

const rutaPrefijo = ref('file');
const modulo = ref('Documento');
const titlePage = ref('Documentos');
const subTitlePage = ref('Gestión de documentos');
if (props.origin_type == 'file_forlevel') {
    titlePage.value = 'Documentos por nivel educativo';
    subTitlePage.value = 'Estos documentos se mostrarán en la plataforma de inicio del estudiante sección Documentos';
} else if (props.origin_type == 'file_guideforcourse') {
    titlePage.value = 'Guía de cursos';
    subTitlePage.value = 'Las guías se muestran en el aula de clase del maestro';
}
</script>

<template>
    <Head :title="titlePage" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PremiumPageHeader 
                :title="titlePage" 
                :subtitle="subTitlePage"
            >
                <template #actions>
                    <Link :href="route('file-create', origin_type)">
                        <BaseButton 
                            color="info" 
                            small 
                            label=" Nuevo documento" 
                            class="ml-2 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors duration-150 border rounded-xl border-blue-600 bg-blue-600 text-white hover:bg-blue-700 p-2 shadow-sm font-semibold text-xs" 
                        />
                    </Link>
                </template>
            </PremiumPageHeader>
        </template>

        <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
            <div class="bg-white dark:bg-slate-900 overflow-hidden shadow-sm sm:rounded-2xl border border-gray-200 dark:border-slate-800 p-6">
                <div v-if="message" class="mb-4 p-3 rounded-xl bg-emerald-50 text-emerald-700 font-medium text-sm border border-emerald-200">
                    {{ message }}
                </div>

                <TableFiles 
                    :modulo="modulo" 
                    :data="files || []" 
                    :ruta="rutaPrefijo" 
                    :originType="origin_type" 
                    :columnas="columnas || []"
                    :objectTarget="object_target || []"
                    :filesDateDiffDays="files_date_diff_days || 15"
                    :canView="canView"
                    :canEdit="canEdit"
                    :canDownload="canDownload"
                />
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>